// Brand
export const BRAND_NAME = 'enviam';
// UIKit version
export const UIKIT_VERSION = '';

// Font Preload
export const PRELOAD_FONTS = [] as const;

//Squircle configuration
export const IS_SQUIRCLE = false;

// button: TYPE || ICON_POSITION
export const BUTTON_DEFAULT_ICON_POSITION = 'left';
export const BUTTON_ICON_POSITION_LEFT = 'left';
export const BUTTON_ICON_POSITION_RIGHT = 'right';

export const BUTTON_ICON_POSITIONS = [BUTTON_ICON_POSITION_LEFT, BUTTON_ICON_POSITION_RIGHT] as const;

export type ButtonIconPosition = (typeof BUTTON_ICON_POSITIONS)[number];

// box: TYPE || CONTENT_HORIZONTAL_ALIGNMENT
export const BOX_DEFAULT_CONTENT_HORIZONTAL_ALIGNMENT = 'left';
export const BOX_CONTENT_HORIZONTAL_ALIGNMENT_LEFT = 'left';
export const BOX_CONTENT_HORIZONTAL_ALIGNMENT_CENTER = 'center';

export const BOX_CONTENT_HORIZONTAL_ALIGNMENTS = [
  BOX_CONTENT_HORIZONTAL_ALIGNMENT_LEFT,
  BOX_CONTENT_HORIZONTAL_ALIGNMENT_CENTER,
] as const;

export type BoxContentHorizontalAlignment = (typeof BOX_CONTENT_HORIZONTAL_ALIGNMENTS)[number];

// box: TYPE || CONTENT_VERTICAL_ALIGNMENT
export const BOX_DEFAULT_CONTENT_VERTICAL_ALIGNMENT = 'top';
export const BOX_CONTENT_VERTICAL_ALIGNMENT_TOP = 'top';
export const BOX_CONTENT_VERTICAL_ALIGNMENT_CENTER = 'center';
export const BOX_CONTENT_VERTICAL_ALIGNMENT_BOTTOM = 'bottom';

export const BOX_CONTENT_VERTICAL_ALIGNMENTS = [
  BOX_CONTENT_VERTICAL_ALIGNMENT_TOP,
  BOX_CONTENT_VERTICAL_ALIGNMENT_CENTER,
  BOX_CONTENT_VERTICAL_ALIGNMENT_BOTTOM,
] as const;

export type BoxContentVerticalAlignment = (typeof BOX_CONTENT_VERTICAL_ALIGNMENTS)[number];

// checkbox: TYPE || GROUP_LABEL_FORMAT
export const CHECKBOX_DEFAULT_GROUP_LABEL_FORMAT = 'copy';
export const CHECKBOX_GROUP_LABEL_FORMAT_H3 = 'h3';
export const CHECKBOX_GROUP_LABEL_FORMAT_H4 = 'h4';
export const CHECKBOX_GROUP_LABEL_FORMAT_H5 = 'h5';
export const CHECKBOX_GROUP_LABEL_FORMAT_ABSTRACT = 'abstract';
export const CHECKBOX_GROUP_LABEL_FORMAT_COPY = 'copy';
export const CHECKBOX_GROUP_LABEL_FORMAT_COPY_SMALL = 'copy-small';

export const CHECKBOX_GROUP_LABEL_FORMATS = [
  CHECKBOX_GROUP_LABEL_FORMAT_H3,
  CHECKBOX_GROUP_LABEL_FORMAT_H4,
  CHECKBOX_GROUP_LABEL_FORMAT_H5,
  CHECKBOX_GROUP_LABEL_FORMAT_ABSTRACT,
  CHECKBOX_GROUP_LABEL_FORMAT_COPY,
  CHECKBOX_GROUP_LABEL_FORMAT_COPY_SMALL,
] as const;

export type CheckboxGroupLabelFormat = (typeof CHECKBOX_GROUP_LABEL_FORMATS)[number];

// headline: TYPE || ALIGNMENT
export const HEADLINE_DEFAULT_ALIGNMENT = 'left';
export const HEADLINE_ALIGNMENT_LEFT = 'left';
export const HEADLINE_ALIGNMENT_CENTER = 'center';

export const HEADLINE_ALIGNMENTS = [HEADLINE_ALIGNMENT_LEFT, HEADLINE_ALIGNMENT_CENTER] as const;

export type HeadlineAlignment = (typeof HEADLINE_ALIGNMENTS)[number];

// link: TYPE || ICON_POSITION
export const LINK_DEFAULT_ICON_POSITION = 'right';
export const LINK_ICON_POSITION_LEFT = 'left';
export const LINK_ICON_POSITION_RIGHT = 'right';

export const LINK_ICON_POSITIONS = [LINK_ICON_POSITION_LEFT, LINK_ICON_POSITION_RIGHT] as const;

export type LinkIconPosition = (typeof LINK_ICON_POSITIONS)[number];

//Icon - Url can be overwritten by build runner
export const ICON_CDN_URL = 'https://cdn.enviam.de/env-ui-component-icons';
export const ICON_VERSION = '1.0.2';

/* Component wise configuration */
// contextMenuItem
export const CONTEXT_MENU_ITEM_ACTIVE_ICON_SIZE = 'small' as const;
// dropdown
export const DROPDOWN_CHEVRON_ICON_NAME = 'chevron_bold_down' as const;
// dropdown
export const DROPDOWN_CHEVRON_SMALL_ICON_NAME = 'chevron_small_down' as const;
// headline
export const HEADLINE_SCHEMES_ON_BACKGROUND_IMAGE = ['red500', 'white'] as const;
// icon
export const ICON_ICON_SCHEME = 'default' as const;
// infoIcon
export const INFO_ICON_ICON_NAME = 'info' as const;
// radioButton
export const RADIO_BUTTON_GROUP_LABEL_FORMAT = ['h3', 'h4', 'h5', 'abstract', 'copy', 'copy-small'] as const;
// tooltip
export const TOOLTIP_CONTENT_ALIGNMENT = ['left'] as const;
export const TOOLTIP_DEFAULT_CONTENT_ALIGNMENT = 'left' as const;
// modal
export const MODAL_FOOTER_COLORS = ['eon-neutral300'] as const;
export const MODAL_FOOTER_DEFAULT_COLOR = 'eon-neutral300' as const;
export const MODAL_HEADLINE_SCHEME = 'red500' as const;
export const MODAL_ICON_SCHEME = 'neutral800' as const;
export const MODAL_HEADLINE_COLORS = ['red500'] as const;
export const MODAL_DEFAULT_HEADLINE_COLOR = 'red500' as const;
